function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "undraw_season_change_f99v");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "200713-HTML-Email",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "200713-Link-expired-",
  transform: "translate(-1198.000000, -627.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "undraw_season_change_f99v",
  transform: "translate(1198.000000, 627.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#FFC222",
  cx: 56,
  cy: 54,
  r: 35
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  fill: "#A6BCD1",
  cx: 339,
  cy: 399.5,
  rx: 339,
  ry: 13.5
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#3FA989",
  cx: 86.5,
  cy: 140.5,
  r: 86.5
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#173948",
  points: "95 400 77 400 85.2055736 127"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#173948",
  points: "86.3046578 179.452326 105 153 86.0488355 186 84 182.333333"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#173948",
  points: "84.6945898 205.452326 66 179 84.9511645 212 87 208.333333"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#173948",
  points: "632 401 614 401 622.205928 128"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#173948",
  points: "624.304658 179.452326 643 153 624.048836 186 622 182.333333"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#173948",
  points: "621.69459 206.452326 603 180 621.951164 213 624 209.333333"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#1E445C",
  cx: 351,
  cy: 240,
  r: 161
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  cx: 350.5,
  cy: 239.5,
  r: 147.5
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#1E445C",
  cx: 350.5,
  cy: 240.5,
  r: 19.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#1E445C",
  x: 346,
  y: 100,
  width: 9,
  height: 16
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#1E445C",
  x: 346,
  y: 365,
  width: 9,
  height: 16
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle",
  fill: "#1E445C",
  transform: "translate(217.500000, 240.000000) rotate(90.000000) translate(-217.500000, -240.000000) ",
  points: "213 232 222 232 222 248 213 248"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle",
  fill: "#3F3D56",
  fillRule: "nonzero",
  transform: "translate(482.500000, 240.000000) rotate(90.000000) translate(-482.500000, -240.000000) ",
  points: "478 232 487 232 487 248 478 248"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#1E445C",
  points: "345 248.803892 352.243075 232 443 283"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#1E445C",
  x: 330,
  y: 40,
  width: 42,
  height: 48
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  fill: "#1E445C",
  cx: 351,
  cy: 40.5,
  rx: 48,
  ry: 13.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M440,268.77312 L437.41737,272.54624 C437.41737,272.54624 425.537276,287.099711 425.020751,280.092487 C424.504227,273.085264 433.801691,268.234104 433.801691,268.234104 L438.966951,265 L440,268.77312 Z",
  id: "Path",
  fill: "#FFB8B8",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M515.859851,280.644923 L518.109816,284.724073 C518.109816,284.724073 525.934023,302.280127 519.389977,299.750765 C512.845932,297.221404 512.614353,286.299842 512.614353,286.299842 L512,280 L515.859851,280.644923 Z",
  id: "Path",
  fill: "#FFB8B8",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#2F2E41",
  fillRule: "nonzero",
  cx: 504,
  cy: 194,
  r: 16
}), /*#__PURE__*/React.createElement("path", {
  d: "M503,326.810398 L505.06557,340.720109 L505.06557,345 L516.942628,345 L516.942628,339.650126 C516.942628,339.650126 517.458998,330.02033 515.39345,327.345386 C513.327902,324.670441 503,326.810398 503,326.810398 Z",
  id: "Path",
  fill: "#FFB8B8",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M481,326.810398 L483.065576,340.720109 L483.065576,345 L494.942628,345 L494.942628,339.650126 C494.942628,339.650126 495.458998,330.02033 493.393451,327.345386 C491.327904,324.670441 481,326.810398 481,326.810398 Z",
  id: "Path",
  fill: "#FFB8B8",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M488.609105,216 C488.609105,216 483.913642,218.475681 487.120723,224.107169 C490.327804,229.738658 509.144525,288 509.144525,288 L520,284.91732 L510.426448,248.071167 L504.94473,224.912825 L488.609105,216 Z",
  id: "Path",
  fill: "#ED0C6E"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#FFB8B8",
  fillRule: "nonzero",
  cx: 502,
  cy: 198,
  r: 12
}), /*#__PURE__*/React.createElement("path", {
  d: "M508,200 L506.375004,225 L495,217.021273 C495,217.021273 498.791665,202.127654 497.708335,201.063789 L508,200 Z",
  id: "Path",
  fill: "#FFB8B8",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M507.829754,222.861753 L495.736925,213.900328 C495.736925,213.900328 490.190091,211.628249 488.586481,214.302887 C486.982872,216.977526 478.964849,256.562281 483.241127,264.051322 C483.241127,264.051322 506.226145,268.865679 511.036957,266.191033 L513.1751,252.282882 C513.1751,252.282882 515.847777,243.724017 511.571491,238.374725 L507.829754,222.861753 Z",
  id: "Path",
  fill: "#ED0C6E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M492,214.950691 C492,214.950691 487.773588,211.755316 484.075468,217.080935 C480.377349,222.406554 436,264.478999 436,264.478999 L443.396224,273 L472.452832,248.502127 L490.943399,233.590376 L492,214.950691 Z",
  id: "Path",
  fill: "#ED0C6E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M510.921988,265.721282 C510.921988,265.721282 484.760194,260.625474 482.117588,264.38028 L481.589091,270.280691 C481.589091,270.280691 475.775358,281.545106 478.946484,299.78274 C482.11761,318.020374 480.003524,329.284797 480.003524,329.284797 C480.003524,329.284797 494.273596,327.67559 504.844014,329.284797 C515.414433,330.894004 517,329.284797 517,329.284797 L510.921988,265.721282 Z",
  id: "Path",
  fill: "#2F2E41",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M518.293474,343 L503,343.532965 L508.273606,383.507148 C508.273606,383.507148 504.05472,400.562785 508.800943,401.628768 C512.100284,402.301864 515.455113,402.658773 518.820811,402.694751 C518.820811,402.694751 523.567057,407.491648 528.840671,406.95866 C532.342915,406.506597 535.736574,405.423479 538.860531,403.760727 C538.860531,403.760727 539.915259,400.562793 536.223724,399.496817 C532.53219,398.430842 522.512338,395.232901 520.402853,384.040136 L518.293474,343 Z",
  id: "Path",
  fill: "#2F2E41",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M496.293471,343 L481,343.532965 L486.273613,383.507148 C486.273613,383.507148 482.054727,400.562785 486.80095,401.628768 C490.10029,402.301864 493.455118,402.658773 496.820815,402.694751 C496.820815,402.694751 501.567061,407.491648 506.840673,406.95866 C510.342917,406.506597 513.736574,405.423479 516.860531,403.760727 C516.860531,403.760727 517.915258,400.562793 514.223725,399.496817 C510.532192,398.430842 500.512364,395.232923 498.402948,384.040159 L496.293471,343 Z",
  id: "Path",
  fill: "#2F2E41",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#2F2E41",
  fillRule: "nonzero",
  cx: 509.5,
  cy: 176.5,
  r: 6.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M518.679246,173.500026 C518.679065,170.172325 516.227906,167.382085 513,167.035141 C513.21939,167.011787 513.439809,167 513.660379,167 C517.161655,167 520,169.910149 520,173.5 C520,177.089851 517.161655,180 513.660379,180 C513.439809,180 513.21939,179.988213 513,179.964859 C516.227887,179.617917 518.679039,176.827707 518.679246,173.500026 Z",
  id: "Path",
  fill: "#2F2E41",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  fill: "#2F2E41",
  fillRule: "nonzero",
  cx: 502,
  cy: 190.5,
  rx: 11,
  ry: 6.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M678.961257,32.4262018 C678.015184,15.6332769 665.100299,1.99555972 648.441687,0.198484816 C631.783075,-1.59859009 616.276777,8.97314563 611.798268,25.180885 C611.38356,25.1659473 610.969234,25.1492174 610.550886,25.1492174 C595.360965,25.1520189 581.988691,35.2011625 577.706244,49.8316705 C567.627413,45.3859159 555.829563,48.331957 549,57 L655.78013,57 C662.07449,57.0177747 668.104841,54.462353 672.482596,49.9220699 C676.86035,45.3817868 679.208189,39.2479685 678.985485,32.9330283 C678.978645,32.7643451 678.970569,32.5954029 678.961257,32.4262018 Z",
  id: "Path",
  fill: "#A6E4E8"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#A6E4E8",
  cx: 589,
  cy: 95,
  r: 9
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#A6E4E8",
  cx: 616.5,
  cy: 73.5,
  r: 7.5
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#A6E4E8",
  cx: 654,
  cy: 114,
  r: 9
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#A6E4E8",
  cx: 585,
  cy: 156,
  r: 9
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#A6E4E8",
  cx: 654,
  cy: 209,
  r: 9
}), /*#__PURE__*/React.createElement("path", {
  d: "M640.122677,385.741832 C640.125842,385.642816 640.137614,385.546039 640.137614,385.446232 C640.142238,382.335629 638.558867,379.437117 635.937068,377.756727 C633.315269,376.076337 630.016531,375.84576 627.185799,377.145025 C624.498974,374.049056 620.072948,373.124188 616.368129,374.884551 C612.663309,376.644915 610.590803,380.657593 611.302707,384.691956 C611.256198,384.691255 611.211121,384.684983 611.164444,384.684983 C607.163784,384.678717 603.622974,387.268321 602.422382,391.078568 C601.221791,394.888815 602.639867,399.036015 605.923531,401.317769 C609.207194,403.599524 613.594883,403.486638 616.756487,401.039061 C618.234074,403.913211 621.12296,405.793738 624.353096,405.984089 C627.583232,406.174441 630.673627,404.646273 632.479593,401.965623 C635.45695,404.128285 639.44317,404.296567 642.592748,402.392559 C645.742327,400.488552 647.44049,396.883901 646.901037,393.247458 C646.361585,389.611014 643.689814,386.652583 640.122677,385.741832 Z",
  id: "Path",
  fill: "#A6E4E8"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#A6E4E8",
  cx: 663,
  cy: 173,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#A6E4E8",
  cx: 638,
  cy: 81,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#A6E4E8",
  cx: 625,
  cy: 176,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#A6E4E8",
  cx: 628,
  cy: 172,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#A6E4E8",
  cx: 631,
  cy: 168,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#A6E4E8",
  cx: 621,
  cy: 200,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#A6E4E8",
  cx: 678,
  cy: 243,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#A6E4E8",
  cx: 596,
  cy: 245,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#A6E4E8",
  cx: 601,
  cy: 127,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#A6E4E8",
  cx: 618,
  cy: 196,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#A6E4E8",
  cx: 614,
  cy: 190,
  r: 4
}))));

var SvgLinkExpired = function SvgLinkExpired(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "682px",
    height: "413px",
    viewBox: "0 0 682 413",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkExpired, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/link-expired.4e0151e4.svg";
export { ForwardRef as ReactComponent };